module.exports = __webpack_public_path__ + "static/media/iconGalleryActive.23cf29ca.svg";